import { useState } from 'react';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { Box } from 'components/common/box';
import {
  AnalyticsCompetenciesChart,
  AnalyticsCompetenciesFilters,
  AnalyticsCompetenciesList
} from '.';

const AnalyticsCompetencies = () => {
  const { messages } = useReduxState();

  const [dataFormat, setDataFormat] = useState('count');
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [url, setUrl] = useState('');

  const { data, loading } = useApiData({ url, onlyIf: Boolean(url) });

  const showPercentages = dataFormat === 'percentage';
  const numberOfUsers = data?.numberOfUsers;

  const ambitionsCountData = data?.ambitions || {};
  const competenciesCountData = data?.competencies || {};

  const ambitionsPercentagesData = {};
  Object.keys(ambitionsCountData).forEach((item) => {
    ambitionsPercentagesData[item] = Math.round(
      (ambitionsCountData[item] / numberOfUsers) * 100
    );
  });

  const competenciesPercentagesData = {};
  Object.keys(competenciesCountData).forEach((item) => {
    competenciesPercentagesData[item] = Math.round(
      (competenciesCountData[item] / numberOfUsers) * 100
    );
  });

  const chartItems = selectedItems.length
    ? selectedItems
    : Object.keys(data?.competencies || {}).slice(0, 5);

  const chartData = chartItems.map((item) => ({
    title: item,
    ambitionsCount: ambitionsCountData[item] || 0,
    competenciesCount: competenciesCountData[item] || 0,
    [messages.analyticsAmbitions]:
      (showPercentages
        ? ambitionsPercentagesData[item]
        : ambitionsCountData[item]) || 0,
    [messages.analyticsCompetencies]:
      (showPercentages
        ? competenciesPercentagesData[item]
        : competenciesCountData[item]) || 0
  }));

  return (
    <div className="competencies-and-ambitions">
      <Box
        headerContent={
          <AnalyticsCompetenciesFilters
            dataFormat={dataFormat}
            setDataFormat={setDataFormat}
            updateData={setUrl}
          />
        }
      >
        <div className="chart">
          <AnalyticsCompetenciesChart
            chartData={chartData}
            loading={loading}
            numberOfUsers={numberOfUsers}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            showPercentages={showPercentages}
          />
        </div>
        <div className="lists" style={{ marginTop: 20 }}>
          <div className="row-md">
            <div className="col-1of2">
              <AnalyticsCompetenciesList
                countData={competenciesCountData}
                emptyMessage={messages.competenciesNoneFound}
                percentagesData={competenciesPercentagesData}
                label={messages.analyticsCompetenciesAll}
                numberOfUsers={numberOfUsers}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                showPercentages={showPercentages}
              />
            </div>

            <div className="col-1of2">
              <AnalyticsCompetenciesList
                countData={ambitionsCountData}
                emptyMessage={messages.settingsNoAmbitionsFound}
                percentagesData={ambitionsPercentagesData}
                label={messages.analyticsAmbitionsAll}
                numberOfUsers={numberOfUsers}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                showPercentages={showPercentages}
              />
            </div>
          </div>
        </div>
      </Box>
    </div>
  );
};

export default AnalyticsCompetencies;
